<template>
  <div class="container-table-striped">
    <div class="table-hover">
      <table class="table content-table-striped table-striped mb-5">
        <thead>
          <tr class="row global-thead-dark thead-property">
            <th id="agencyName" class="col-md-3">
              Agencia
            </th>
            <th id="agencyPhone" class="col-md-3">
              Número
            </th>
            <th id="agencyDescription" class="col-md-3">
              Servicio(s)
            </th>
            <th id="agencyActions" class="col-md-3" />
          </tr>
        </thead>
        <tbody v-if="!isAddMode">
          <tr v-for="(item, index) in serviceAgencies" :key="index" class="row">
            <td class="col-md-3 text-left custom-column-separator">
              {{ item.agencyName }}
            </td>
            <td class="col-md-3 text-left custom-column-separator">
              {{ item.recordNumber }}
            </td>
            <td class="col-md-3 text-left custom-column-separator">
              {{ item.serviceDescription }}
            </td>
            <td class="col-md-3 text-right">
              <button
                v-if="!disabled"
                class="btn btn-dropdown-actions dropdown-toggle pt-1"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Acciones
              </button>
              <div class="dropdown-menu dropdown-menu-right pb-0">
                <a
                  :id="`hlEdit-${index}`"
                  class="drop-item cursor-pointer"
                  @click="editItem(item)"
                >
                  <em class="fas fa-pencil-alt text-green pr-2" />
                  <span>Editar</span>
                </a>
                <a
                  :id="`hlDelete-${index}`"
                  class="drop-item cursor-pointer"
                  @click="confirmDelete(item)"
                >
                  <em class="fas fa-times-circle text-red pr-2" />
                  <span>Eliminar</span>
                </a>
              </div>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="row">
            <td class="col-md-12">
              <div
                v-if="!isAddMode && serviceAgencies.length > 0"
                class="text-right mr-n3"
              >
                <ActionButton
                  v-if="!disabled"
                  id="btnAddAgency"
                  i="fas fa-file-plus"
                  variant="success m-2 pl-4 pr-4"
                  type="submit"
                  :disabled="disabled"
                  @click="addAgency"
                >
                  Añadir
                </ActionButton>
              </div>
              <div
                v-if="!isAddMode && serviceAgencies.length == 0"
                class="text-center"
              >
                <button
                  id="btnAddAgency"
                  class="btn bg-light-white w-50 pt-1 mt-2 button-add"
                  :disabled="disabled"
                  @click="addAgency"
                >
                  <em class="fas fa-plus-square pr-4 text-green custom-icon" />
                  <span class="text-button-add-document">
                    Presione aquí para añadir servicios de otras agencias
                  </span>
                </button>
              </div>
              <OtherAgencyServiceAdd
                v-if="isAddMode"
                :agency="agency"
                :student-sie-id="studentSieId"
                @on-save="onSave"
                @on-cancel="onCancel"
              />
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapGetters } = createNamespacedHelpers('$_student');
import { ActionButton } from '@/components/common';
import OtherAgencyServiceAdd from './OtherAgencyServiceAdd';
import alertMixin from '@/mixin/alert.mixin';

//endpoints
const GET_SERVICE_AGENCY_LIST = 'api/studentregistry/getserviceagencies';
const CREATE_SERVICE_AGENCY = 'api/studentregistry/createserviceagency';
const UPDATE_SERVICE_AGENCY = 'api/studentregistry/updateserviceagency';
const DELETE_SERVICE_AGENCY = 'api/studentregistry/deleteserviceagency';

export default {
  name: 'OtherAgencyService',
  data() {
    return {
      serviceAgencies: [],
      agency: null,
      isAddMode: false,
    };
  },
  props: {
    disabled: {
      type: Boolean,
      default: () => false,
    },
  },
  mixins: [alertMixin],
  computed: {
    ...mapGetters({
      selectedStudent: 'SelectedStudent',
      selectedPreRegistry: 'getStudentPreRegistry',
    }),
    studentSieId() {
      return parseInt(this.selectedStudent.studentId);
    },
    regStudentId() {
      return this.selectedPreRegistry.regStudentId;
    },
  },
  methods: {
    async getServiceAgenciesAsync() {
      if (this.studentSieId) {
        const { data: serviceAgencies } = await this.$ApiGet(
          `${GET_SERVICE_AGENCY_LIST}/${this.studentSieId}`
        );
        if (serviceAgencies) {
          this.serviceAgencies = serviceAgencies;
        }
      }
    },
    async addServiceAgencyAsync(info) {
      if (info && this.studentSieId && this.regStudentId) {
        const params = {
          studentSieId: this.studentSieId,
          regStudentId: this.regStudentId,
          recordNumber: info.recordNumber,
          serviceDescription: info.serviceDescription,
          agencyId: info.agencyId,
          oldAgencyId: info.agencyId,
        };
        const { data: addResult } = await this.$ApiPost(
          CREATE_SERVICE_AGENCY,
          params,
          true
        );
        if (addResult) {
          this.isAddMode = false;
          this.getServiceAgenciesAsync();
        }
      }
    },
    async updateServiceAgencyAsync(info) {
      if (info && this.selectedStudent) {
        await this.$ApiPut(UPDATE_SERVICE_AGENCY, info, true);
        this.isAddMode = false;
        this.getServiceAgenciesAsync();
      }
    },
    async deleteAgencyAsync(item) {
      if (this.studentSieId && item) {
        await this.$ApiDelete(
          `${DELETE_SERVICE_AGENCY}/${item.agencyId}/${this.regStudentId}`
        );
        this.getServiceAgenciesAsync();
      }
    },
    addAgency() {
      this.agency = null;
      this.isAddMode = true;
    },
    editItem(info) {
      if (info) {
        this.agency = { ...info };
        this.isAddMode = true;
      }
    },
    async onSave(info, isEditMode) {
      if (info) {
        if (!isEditMode) {
          await this.addServiceAgencyAsync(info);
        } else {
          await this.updateServiceAgencyAsync(info);
        }
      }
    },
    async confirmDelete(item) {
      let alertResponse = await this.ShowCancelModal(
        'Atención',
        '¿Está seguro que desea eliminar la agencia?',
        'Si',
        'No'
      );
      if (alertResponse) {
        await this.deleteAgencyAsync(item);
      }
    },
    onCancel() {
      this.isAddMode = false;
    },
  },
  async mounted() {
    await this.getServiceAgenciesAsync();
  },
  components: {
    ActionButton,
    OtherAgencyServiceAdd,
  },
};
</script>

<style scoped>
.thead-property {
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px 5px 0px 0px;
}

.btn-dropdown-actions {
  text-align: center;
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  color: rgb(12, 19, 16);
  border-radius: 4px;
  margin-right: 0px;
  border: 1px solid #2db782;
  width: 7.8125rem;
  height: 2.25rem;
}

.drop-item {
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 0.9375rem;
  color: #11291b;
  text-align: inherit;
  white-space: nowrap;
  display: block;
  padding: 0.29rem 1.5rem;
  clear: both;
}

.drop-item:hover {
  text-decoration: none;
  color: #727272;
}

.btn-dropdown-actions {
  text-align: center;
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  color: rgb(12, 19, 16);
  border-radius: 4px;
  margin-right: 0px;
  border: 1px solid #2db782;
  width: 7.8125rem;
  height: 2.25rem;
}

.custom-icon {
  font-size: 17px;
}

.custom-column-separator {
  padding-left: 33px;
}
</style>
